/**
 * Horizontal filter pill bar behaviour (desktop collection + search pages).
 *
 * The filter groups use the theme's <details-disclosure> elements. This adds
 * dropdown UX on top: opening one pill closes the others, and clicking or
 * tabbing outside the bar closes any open pill. The mobile drawer is untouched.
 *
 * All listeners are delegated on `document` and re-query the bar on each event,
 * because facet-filters.js replaces the whole <form> (and therefore the bar)
 * every time a filter is applied.
 */
(function () {
  const DESKTOP = "(min-width: 1024px)";
  // Sections that render the filters as a horizontal pill bar. Kept in sync
  // with the CSS scopes in facet-filters.css / products-grid.css.
  const SECTIONS = [".cc-collection-products", ".cc-main-search"];
  const BAR_SELECTOR = SECTIONS.map((s) => `${s} .facets__filters`).join(", ");
  const SUMMARY_SELECTOR = SECTIONS.map(
    (s) => `${s} .facets__filters summary.filter__toggle`
  ).join(", ");
  const mq = window.matchMedia(DESKTOP);

  function openDetailsInBar(bar) {
    if (!bar) return [];
    return Array.from(bar.querySelectorAll(":scope > details-disclosure > details[open]"));
  }

  function closeDetails(details) {
    const host = details.parentElement; // <details-disclosure>
    if (host && typeof host.close === "function") host.close();
    else details.open = false;
  }

  function closeAll(except) {
    const bar = document.querySelector(BAR_SELECTOR);
    openDetailsInBar(bar).forEach((details) => {
      if (details !== except) closeDetails(details);
    });
  }

  // Opening a pill closes the others.
  document.addEventListener("click", (evt) => {
    if (!mq.matches) return;

    const summary = evt.target.closest(SUMMARY_SELECTOR);
    if (summary) {
      const details = summary.closest("details");
      // Let the disclosure's own handler flip the state first.
      requestAnimationFrame(() => {
        if (details && details.open) closeAll(details);
      });
      return;
    }

    // A click anywhere outside the bar closes every open pill.
    if (!evt.target.closest(BAR_SELECTOR)) closeAll(null);
  });

  // Escape closes everything.
  document.addEventListener("keydown", (evt) => {
    if (evt.key === "Escape" && mq.matches) closeAll(null);
  });
})();
